module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/contentoffice/3.png?6ff6aeba0e2c973b9721d00fc608139c";